var React = require('react');

function EditIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Mask"},React.createElement("path",{"id":"path-1_1_","fill":"#414042","d":"M10.616,5.193l-6.562,6.604l-1.048,3.241l3.15-1.159l6.659-6.594L10.616,5.193z\r\n\t\t M5.562,12.137L5.2,11.776l5.425-5.451l0.361,0.36L5.562,12.137z M12.799,3l2.197,2.092l-1.439,1.447l-2.197-2.092L12.799,3z"})));
}

EditIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"18px","height":"18px","viewBox":"0 0 18 18","enableBackground":"new 0 0 18 18","xmlSpace":"preserve"};

module.exports = EditIcon;

EditIcon.default = EditIcon;
